import GolfTee from "../../svgs/GolfTee";
import Magazine from "../../svgs/Magazine";
import Press from "../../svgs/Press";

export const contentObject = {
  "golf-coach": {
    title: "Golf Coach",
    description: "Please review your previous submissions for this cycle before proceeding.",
    description2:
      "Serving as a golf coach or assistant golf coach of a high school/college golf team in a capacity not considered the member's primary employment.",
    list: ["Each activity can only be submitted once", "6 Credits Per Submission", "Maximum of 6 credits per PDR cycle year"],
    maxCredits: 6,
    icon: GolfTee,
    descriptionText: "Briefly describe the coaching activity. (limit 500 characters).",
    descriptionPlaceholder: "Ex. I served as a NCCGA coach for several months.  I assisted with training, instruction, and...",
  },
  "media-related-articles": {
    title: "Media Related Articles",
    description: "Please review your previous PDR submissions for this cycle before proceeding.",
    description2: "PGA-approved news, media, magazine articles or published book.",
    list: ["Each activity can only be submitted once", "1 Credit Per Article", "Maximum of 4 credits per PDR cycle year"],

    maxCredits: 4,
    icon: Magazine,
    descriptionText: "Enter the title, publication, and description for the article. ",
    descriptionPlaceholder: "Ex. Article “title” was published in “publication name”.  The article is about “subject(s)”.",
  },
  "service-to-pga-industry": {
    title: "Service to PGA/Industry",
    description: "Please review your previous submissions for this cycle before proceeding.",
    description2:
      "Serving the Section, Chapter, National PGA or Allied Association. Participating in advancement of the game activities such as radio shows, TV shows, speeches, golf promotional non-playing events, golf clinics and other volunteer activities, such as non-playing tournament official.",
    list: ["Each activity can only be submitted once", "1 Credit Per Hour of Participation", "Maximum of 8 credits per day"],
    icon: Press,
    maxCredits: 8,
    descriptionText: "Provide a brief description of the activity/service.",
    descriptionPlaceholder: "Ex. Participated in a promotional event where I gave a presentation about...",
  },
};
